export const UPDATE_BOOKING_COMMON_UI = 'UPDATE_BOOKING_COMMON_UI';
export const UPDATE_BOOKING_MONEY = 'UPDATE_BOOKING_MONEY';
